import { Col, Form, FormInstance, Input, Row, Select } from 'antd'

import { Placeholder } from 'src/api/requests'
import { requiredRules } from 'src/app-constants'
import { RichTextEditor } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  language: string
  placeholders: Placeholder[]
  form: FormInstance
}

export const NotificationContentFormItems = ({
  language,
  placeholders,
  form
}: Props) => {
  const { t } = useLocales()

  const onSelect = (value?: string | null) => {
    const content = form.getFieldValue(`content_${language}`) || ''

    const placeholderText = ` {{${value}}}`
    let updatedContent = content

    const lastPIndex = content.lastIndexOf('</p')
    if (lastPIndex !== -1) {
      updatedContent =
        content.slice(0, lastPIndex) +
        placeholderText +
        content.slice(lastPIndex)
    } else {
      updatedContent = content + placeholderText
    }

    form.setFieldValue(`content_${language}`, updatedContent)
  }

  const placeholdersOptions = placeholders?.map((placeholder) => ({
    value: placeholder.property,
    label: placeholder.title
  }))

  return (
    <Row gutter={[16, 16]}>
      <Col span={16}>
        <Form.Item
          label={t('notification_templates.notification_title')}
          name={`title_${language}`}
          rules={requiredRules}
        >
          <Input placeholder={t('notification_templates.notification_title')} />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label={<></>}>
          <Select
            options={placeholdersOptions}
            value={t('notification_templates.placeholders')}
            onSelect={onSelect}
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          label={t('notification_templates.content')}
          name={`content_${language}`}
          rules={requiredRules}
        >
          <RichTextEditor placeholder={t('notification_templates.content')} />
        </Form.Item>
      </Col>
    </Row>
  )
}
